import { CmmFile, CmmFileHeader } from '../../shared/types/cmmReport.ts';
import { trpcClient } from '../utils/trpc/trpc.ts';


export async function fetchCmmFile(fileName: string): Promise<File> {
    const data = await trpcClient.cmmReports.getFile.query({ fileName });
    const file = new File([data], fileName);
    return file;
}

export async function fetchCmmFiles(fileNames: string[]): Promise<File[]> {
    const files = await Promise.all(fileNames.map(fetchCmmFile));
    return files;
}

export async function fetchCmmReports(orderNumber: string): Promise<CmmFile[]> {
    const cmmReportHeaders = await trpcClient.cmmReports.getHeaders.query({ startsWith: orderNumber });

    const names = cmmReportHeaders.map(it => it.name);
    const files = await Promise.all(names.map(fetchCmmFile));

    const cmmReports = cmmReportHeaders.map((it, index) => ({
        ...it,
        file: files[index],
    }));
    return cmmReports;
}

export async function fetchCmmHeaderFiles(cmmReportHeaders: CmmFileHeader[]): Promise<CmmFile[]> {
    const fileNames = cmmReportHeaders.map(it => it.name);
    const files = await fetchCmmFiles(fileNames);

    return cmmReportHeaders.map((header, index) => ({
        ...header,
        file: files[index],
    }));
}
